import Model, { attr, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { CentralMappingPmsValueType } from 'lumen/models';
import type { Breakdown } from 'lumen/utils/central-mapping-constants';

export default class CentralMappingBreakdown extends Model {
  [Type] = 'central-mapping/breakdown' as const;

  @hasMany('central-mapping/pms-value-type', { async: false, inverse: null })
  declare valueTypes: CentralMappingPmsValueType[];

  @attr('boolean') declare available: boolean;
  @attr('string') declare breakdown: Breakdown;
  @attr('number') declare totalValuesUnmapped: number;
}
